import React, { FC, useRef, useState } from 'react';
import { useHistory } from 'react-router';

import { Button } from 'devextreme-react/button';
import DataGrid, {
  Column,
  ColumnChooser,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Lookup,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import $createStore from 'utils/create-store-instance';
import { maskedPhone } from 'utils/masked-phone';

import { typeContractor } from 'types/books';

import DeleteModal from './components/ContractorLegalDeleteModal/ContractorLegalDeleteModal';
import AddEditModal from './components/ContractorLegalEditAddModal/ContractorLegalEditAddModal';

const ContractorLegalDataStoreN: any = $createStore('/v1/ContractorLegal', 'id');

const ContractorLegalPage: FC = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const [openId, setOpenId] = useState<number | null>(null);

  const [visibleDelete, setVisibleDelete] = useState<boolean>(false);
  const [openIdDelete, setOpenIdDelete] = useState<number | null>(null);

  const refGrid = useRef<DataGrid | null>(null);

  const history = useHistory();

  return (
    <div className="container-dev">
      <AppLayoutTop title="Юр. лица">
        <ClaimsProvider claimsBlock={['CanCreateLegalContractor']}>
          <Button
            width={120}
            text="Создать"
            type="default"
            //onClick={() => refGrid.current?.instance.addRow()}
            onClick={() => {
              setOpenId(null);
              setVisible(true);
            }}
          />
        </ClaimsProvider>
      </AppLayoutTop>

      <AddEditModal
        visible={visible}
        changeVisible={(show) => setVisible(show)}
        id={openId}
        refresh={() => refGrid.current?.instance.refresh()}
      />

      <DeleteModal
        visible={visibleDelete}
        changeVisible={(show) => setVisibleDelete(show)}
        id={openIdDelete}
        refresh={() => refGrid.current?.instance.refresh()}
      />

      <AppCard>
        <DataGrid
          dataSource={ContractorLegalDataStoreN}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
          onRowDblClick={(e) => history.push(`/contractor-detail/${e.data.id}`)}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
        >
          <StateStoring enabled={true} type="localStorage" storageKey="contractorLegal" />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <ColumnChooser enabled={true} />

          <Column dataField="name" caption="Наименование" sortOrder="asc" />
          <Column dataField="contractorType" caption="Тип">
            <Lookup dataSource={typeContractor} valueExpr="id" displayExpr="name" />
          </Column>
          <Column dataField="inn" caption="ИНН" />
          <Column dataField="phone" caption="Телефон" cellRender={({ data }) => maskedPhone(data.phone)} />
          <Column dataField="isOwner" caption="Собст. организация" />
          <Column
            dataField=""
            caption=""
            width={150}
            cellRender={(data) => (
              <ClaimsProvider claimsBlock={['CanEditLegalContractor']}>
                <div>
                  <Button
                    icon="edit"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      history.push(`/contractor-detail/${data.data.id}`);
                    }}
                  />
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setOpenIdDelete(data.key);
                      setVisibleDelete(true);
                    }}
                  />
                </div>
              </ClaimsProvider>
            )}
          />

          <Column dataField="comment" caption="Комментарий" width={200} visible={false} />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default ContractorLegalPage;
